import { TableRow } from '@material-ui/core';
import TableHeader from './TableHeader/TableHeader';
import TableHead from './TableHead/TableHead';
import TableCell from './TableCell/TableCell';
import TableWrapper from './TableWrapper/TableWrapper';
import Table from './Table/Table';
import EmptyRow from './EmptyRow/EmptyRow';
import TableBody from './TableBody/TableBody';
import TableFooter from './TableFooter/TableFooter';

export default {
  TableHeader,
  TableHead,
  TableCell,
  TableWrapper,
  Table,
  EmptyRow,
  TableBody,
  TableFooter,
  TableRow
};
